module.exports = __webpack_public_path__ + "img/cog.2498da93.svg";